import React from 'react';
import { useAuth } from '../../context/AuthContext';
import SessionTimeoutModal from './SessionTimeoutModal';

const SessionTimeoutWrapper: React.FC = () => {
  const { showTimeoutWarning, extendSession } = useAuth();

  return (
    <SessionTimeoutModal
      isOpen={showTimeoutWarning}
      onExtendSession={extendSession}
    />
  );
};

export default SessionTimeoutWrapper; 